export default class MaterialReportModel {
    /**
     * Creates an instance of Harja compatible material.
     */
    constructor(
        materialDry, dryAmount, dryUnit, materialLiquid, liquidAmount, liquidUnit
    ) {
         /** @type {number | null} */
        this.materialReportDryMaterial = materialDry

         /** @type {number} */
        this.materialReportDryAmount = dryAmount

         /** @type {string | null} */
         this.materialReportDryUnit = dryUnit
        
         /** @type {number| null} */
         this.materialReportLiquidMaterial = materialLiquid

         /** @type {number} */
         this.materialReportLiquidAmount = liquidAmount

         /** @type {string | null} */
         this.materialReportLiquidUnit = liquidUnit
    }
    /**
    * Get the culvert json object.
    * @returns {object}
    */
    toJSON() {
        return JSON.parse(
            JSON.stringify({
            materialReportDryMaterial: this.materialReportDryMaterial,
            materialReportDryAmount: this.materialReportDryAmount,
            materialReportDryUnit: this.materialReportDryUnit,
            materialReportLiquidMaterial: this.materialReportLiquidMaterial,
            materialReportLiquidAmount: this.materialReportLiquidAmount,
            materialReportLiquidUnit: this.materialReportLiquidUnit
        }))
    }
}